import { getAuth } from 'firebase/auth';
import { app } from '../firebase';

const PAYBILL_API_URL = (process.env.REACT_APP_PAYBILL_API_URL ||
  'https://europe-west1-ubunifu-college.cloudfunctions.net/paybillApi').replace(/\/$/, '');

export async function paybillApi(path, { method = 'GET', body } = {}) {
  const user = getAuth(app).currentUser;
  if (!user) {
    throw new Error('Your admin session has expired. Sign in again.');
  }

  const idToken = await user.getIdToken();
  const response = await fetch(`${PAYBILL_API_URL}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${idToken}`,
      ...(body ? { 'Content-Type': 'application/json' } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const explanation = payload.details && payload.details !== payload.error
      ? `${payload.error || 'Paybill API request failed.'} ${payload.details}`
      : payload.error || `Paybill API returned ${response.status}.`;
    throw new Error(explanation);
  }
  return payload;
}
